import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BreadCrumb from "../Controls/BreadCrumb";
import CustomButton from "../Controls/CustomButton";
import API from "@src/API.js";
import { toast } from "react-toastify";
import "../../style/scss/Recruit.scss";

const INTEREST_OPTIONS = [
  { value: "VeryInterested", label: "Very interested" },
  { value: "Interested", label: "Interested" },
  { value: "Maybe", label: "Maybe" },
  { value: "NotInterested", label: "Not interested" },
];

export default function JobInterestResponse() {
  const { id: idStr } = useParams();
  const jobCandidateId = Number.parseInt(idStr, 10);
  const navigate = useNavigate();
  const [jobTitle, setJobTitle] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [current, setCurrent] = useState("");
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      if (!jobCandidateId) return;
      setLoading(true);
      try {
        const resp = await API.getAsync(`/JobCandidate?id=${jobCandidateId}`);
        if (resp?.ok && resp.jsonData) {
          setJobTitle(resp.jsonData.JobTitle || resp.jsonData.jobTitle || "");
          setEmployerName(resp.jsonData.EmployerName || resp.jsonData.employerName || "");
          setCurrent(resp.jsonData.OpeningInterest || resp.jsonData.openingInterest || "");
        } else {
          toast.error(resp?.jsonData?.message || "Could not load opening");
        }
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [jobCandidateId]);

  async function submit(interest) {
    setBusy(true);
    try {
      const resp = await API.postAsync("/JobCandidate/Interest", {
        JobCandidateID: jobCandidateId,
        Interest: interest,
      });
      if (resp?.ok) {
        setCurrent(interest);
        toast.success("Interest recorded");
      } else {
        toast.error(resp?.jsonData?.message || "Could not save interest");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="pagebody JobInterestResponse">
      <BreadCrumb
        props={[
          { label: "Dashboard", route: "/dashboard" },
          { label: "Job interest", route: `/jobInterest/${jobCandidateId}` },
        ]}
      />
      <div className="tabbody">
        <h1>Job opening interest</h1>
        {loading ? <p>Loading…</p> : null}
        <p className="byline">
          {jobTitle
            ? `${jobTitle}${employerName ? ` at ${employerName}` : ""}`
            : `Opening #${jobCandidateId}`}
        </p>
        <p>
          A recruiter selected you from system-ranked matches. Share how interested you are — this is
          not a job board browse.
        </p>
        {current ? (
          <p>
            Current response: <strong>{current}</strong>
          </p>
        ) : null}
        <div className="interestActions">
          {INTEREST_OPTIONS.map((opt) => (
            <CustomButton
              key={opt.value}
              type="button"
              variant="contained"
              color={opt.value === "NotInterested" ? "error" : "primary"}
              disabled={busy}
              className={current === opt.value ? "selected" : ""}
              onClick={() => submit(opt.value)}
            >
              {opt.label}
            </CustomButton>
          ))}
        </div>
        <CustomButton type="button" variant="outlined" color="secondary" className="backBtn" onClick={() => navigate("/dashboard")}>
          Back to dashboard
        </CustomButton>
      </div>
    </div>
  );
}
